
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai/proactive-load-audits",
      function () {
        return require("private-next-pages/ai/proactive-load-audits.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai/proactive-load-audits"])
      });
    }
  